export default "skymp5-front/012ba60b5cafa40f9e478f978761f33d.svg";